module.exports = __webpack_public_path__ + "static/media/logo.e393b73f.svg";